import { useMediaQuery } from 'react-responsive'

const BREAK_POINT = {
  xs: 480,
  sm: 576,
  md: 768,
  lg: 1024,
  xl: 1200,
  pc: 1280,
  xxl: 1600,
} as const

export const useQueryScreen = (type: 'xxl' | 'xl' | 'lg' | 'md' | 'sm' | 'xs' | 'max-md' | 'pc' = 'lg') => {
  const getScreenType = () => {
    switch (type) {
      case 'xxl':
        return `(min-width: ${BREAK_POINT.xxl}px)`
      case 'xl':
        return `(min-width: ${BREAK_POINT.xl}px)`
      case 'pc':
        return `(min-width: ${BREAK_POINT.pc}px)`
      case 'lg':
        return `(min-width: ${BREAK_POINT.lg}px)`
      case 'md':
        return `(min-width: ${BREAK_POINT.md}px)`
      case 'max-md':
        return `(max-width: ${BREAK_POINT.md - 1}px)`
      case 'sm':
        return `(min-width: ${BREAK_POINT.sm}px)`
      case 'xs':
        return `(min-width: ${BREAK_POINT.xs}px)`
    }
  }

  const result = useMediaQuery({
    query: getScreenType(),
  })

  return result
}
